var map = {
	"./de-de/messages.ts": [
		9600,
		600
	],
	"./en-gb/messages.ts": [
		54585,
		585
	],
	"./en-us/messages.ts": [
		84106,
		106
	],
	"./es-es/messages.ts": [
		59429,
		429
	],
	"./fr-fr/messages.ts": [
		91108,
		108
	],
	"./it-it/messages.ts": [
		59378,
		378
	],
	"./ja-ja/messages.ts": [
		63994,
		994
	],
	"./pseudo/messages.ts": [
		37418,
		418
	],
	"./pt-br/messages.ts": [
		70816,
		816
	],
	"./pt-pt/messages.ts": [
		93281,
		281
	],
	"./ru-ru/messages.ts": [
		64991,
		991
	],
	"./vi-vn/messages.ts": [
		86781,
		781
	],
	"./zh-hans/messages.ts": [
		99121,
		121
	],
	"./zh-hant/messages.ts": [
		34055,
		55
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 53863;
module.exports = webpackAsyncContext;